import { atom } from '@reatom/framework';
export class Observable {
    __INTERNAL_DO_NOT_USE_ATOM__;
    constructor(a) {
        this.__INTERNAL_DO_NOT_USE_ATOM__ = a;
    }
}
export function createObservable(value) {
    return new Observable(atom(value));
}
export function createObservableFromAtom(a) {
    return new Observable(a);
}
